import { clearMfaToken, removeProfile, setAccessToken, setRefreshToken } from '@/utils/tokenStore';
import router from '../router';
import { message } from 'ant-design-vue';

export const bridges = () => {
    return {

        /*
        
        웹 > 앱, 앱 > 웹 통신을 담당하는 메소드 모음.

        사용법:

        1. 본 파일 내 선언 및 메소드 구현
        2. App.vue > intBridges에서 window 객체에 바인딩
        3. 필요한 순간에 호출

        checkIsLoggedIn(웹 > 앱), requestLogoutFromApp(앱 > 웹)
        전체검색 하시면 실사용 코드를 확인할 수 있습니다.
        
        */



        /*
        
        웹에서 앱 쪽으로 송신하는 유형의 메소드(이하 webToApp)
        
        */
        webToApp: (data) => {
            const userAgent = navigator.userAgent.toLowerCase();
            console.log(`webToApp, 디바이스: ${userAgent}, 수신 값: ${JSON.stringify(data)}`)
            if (userAgent.indexOf('android') !== -1) {
                //안드로이드
                /*
                 * 객체가 아니라 메서드가 있는지 본다(iOS 분기와 같은 방식).
                 *
                 * 제조사 안드로이드 앱의 WebViewBridge 에는 webToApp 이 없다(checkIsLoggedIn·스캔 계열만 있음).
                 * 예전에는 객체만 확인하고 불러 TypeError 가 났고, 토큰 재발행이 실패했을 때
                 * 뒤이은 세션 정리·로그인 화면 이동이 실행되지 않아 앱을 켤 때마다
                 * 「정보 조회 실패」가 반복됐다(2026-10-28 실기기 재현).
                 */
                if (typeof window.WebViewBridge?.webToApp === 'function') {
                    window.WebViewBridge.webToApp(data);
                } else {
                    console.log('WebViewBridge.webToApp does not exist');
                }
            } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
                // ios
                if (window.webkit?.messageHandlers && window.webkit?.messageHandlers?.webToApp) {
                    window.webkit.messageHandlers.webToApp.postMessage(data);
                }
            } else { 
                //기타
                window.opener?.postMessage(data);
            }
        },
        /*
        
        앱에서 웹 쪽으로 송신(이하 appToWeb)
        
        */
        appToWeb: (input) => {
            console.log(`appToWeb, 수신 파라미터: ${input}`)
            const obj = {};
            const newInput = JSON.stringify(input)
            if(newInput && typeof newInput.accessToken !== 'undefined') {
                setAccessToken(newInput.accessToken);
            }
            if(newInput && typeof newInput.refreshToken !== 'undefined') {
                setAccessToken(newInput.refreshToken);
            }
        },
        /*
        
        앱에서 로그아웃 요청(appToWeb)
        
        */
        requestLogoutFromApp: () => {
            console.log(`requestLogoutFromApp`)
            setAccessToken(null);
            setRefreshToken(null);
            clearMfaToken();
            removeProfile('nameManu');
            removeProfile('managerManu');
            removeProfile('companyManu');
            removeProfile('companyImageUrlManu');
            removeProfile('CompanyInfo');
            removeProfile('companyImageUrlManu');
            window.checkIsLoggedIn({
              isLoggedIn:false,
              accessToken:null,
              refreshToken:null,
            });
            router.push('/signin');
            
            return true;
        },
        /*
        
        웹에서 로그인 상태 앱으로 보냄(webToApp)
        
        */
        checkIsLoggedIn: (data) => {
            const userAgent = navigator.userAgent.toLowerCase();
            console.log(`checkIsLoggedIn, 디바이스: ${userAgent}, 수신 값: ${JSON.stringify(data)}`)
            if (userAgent.indexOf('android') !== -1) {
                //안드로이드
                if (typeof WebViewBridge !== 'undefined' && WebViewBridge) {
                    WebViewBridge.checkIsLoggedIn(JSON.stringify(data));
                } else {
                    console.log('WebViewBridge does not exist');
                }
            } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
                // ios
                if (window.webkit?.messageHandlers && window.webkit?.messageHandlers?.checkIsLoggedIn) {
                    window.webkit.messageHandlers.checkIsLoggedIn.postMessage(data);
                }
            } else { 
                //기타
                window.opener?.postMessage(JSON.stringify(data));
            }
        },
        
        //MARK: webToApp_TEST
        /*
        data = { key0: 'valueString0', key1: 12345, key2: false }
        */
        requestWebToApp_TEST: (data) => {

            console.log(`bridges requestWebToApp_TEST method BEGIN`);

            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    console.log(`${key}: ${data[key]}`);
                }
            }

            const userAgent = navigator.userAgent.toLowerCase();

            //aos는 반드시 stringfy를 해서 보내야 하나...그게 맞았떤 걸로 기억하는데...
            console.log(`bridges requestWebToApp_TEST method \n 디바이스: ${userAgent}, 수신 값: ${JSON.stringify(data)}`);

            if (userAgent.indexOf('android') !== -1) {

                console.log('bridges requestWebToApp_TEST aos');

                //안드로이드
                if (typeof WebViewBridge !== 'undefined' && WebViewBridge) {
                    WebViewBridge.requestWebToApp_TEST(JSON.stringify(data));
                } else {
                    console.log('bridges requestWebToApp_TEST does not exist');
                }
            } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {

                console.log('bridges requestWebToApp_TEST ios');

                // ios
                if (window.webkit?.messageHandlers && window.webkit?.messageHandlers?.requestWebToApp_TEST) {
                    window.webkit.messageHandlers.requestWebToApp_TEST.postMessage(data);
                }
            } else { 

                console.log('bridges requestWebToApp_TEST else unknown');

                //기타
                window.opener?.postMessage(data);
            }

            console.log(`bridges requestWebToApp_TEST method END`);
        },

        //MARK: appToWeb_TEST
        /*
        data = { key0: 'valueString0', key1: 12345, key2: false }
        */
        requestAppToWeb_TEST: (data) => {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    console.log(`${key} : ${data[key]}`);
                }
            }

            const userAgent = navigator.userAgent.toLowerCase();
            console.log(`bridges requestAppToWeb_TEST method \n 디바이스: ${userAgent}, 수신 값: ${JSON.stringify(data)}`);

            if (userAgent.indexOf('android') !== -1) {
                //안드로이드
                console.log('bridges requestWebToApp_TEST aos called');
            } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
                // ios
                console.log('bridges requestAppToWeb_TEST ios called');
            } else { 
                //기타
                console.log('bridges requestAppToWeb_TEST else unknown');
            }
        },
    }
}
